(() => {
  'use strict';
  const salesPage = document.currentScript.dataset.sales === 'true';
  const offerSelectors = [
    '.collection-image-description__content',
    '.collection-banner-custom__description',
    '.collection-banner__content .rte'
  ];
  if (salesPage) offerSelectors.push('.text-overlay__heading', '.text-overlay__block.rte');
  const ignored = 'a, button, script, style, input, textarea, select';
  const timers = new WeakMap();
  let status;

  function makeButton(code) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'as-coupon-copy';
    button.dataset.couponCode = code;
    button.setAttribute('aria-label', `Copy coupon code ${code}`);
    const value = document.createElement('span');
    value.className = 'as-coupon-copy__code';
    value.textContent = code;
    const label = document.createElement('span');
    label.className = 'as-coupon-copy__label';
    label.setAttribute('aria-hidden', 'true');
    label.textContent = 'Copy';
    button.append(value, document.createTextNode(' '), label);
    return button;
  }

  function enhanceOffer(container) {
    if (container.closest(ignored)) return;
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let text = '';
    while (walker.nextNode()) {
      const node = walker.currentNode;
      nodes.push({ node, start: text.length, end: text.length + node.length });
      text += node.textContent;
    }
    const pattern = /\b(?:use|with)\s+(?:coupon\s+|promo\s+)?code\s*:?\s*([a-z0-9][a-z0-9_-]*)(?=[\s.,!;:]|$)/gi;
    // Work backwards so replacing a code cannot shift earlier text offsets.
    [...text.matchAll(pattern)].reverse().forEach((match) => {
      const code = match[1];
      const start = match.index + match[0].length - code.length;
      const end = start + code.length;
      const parts = nodes.filter((part) => part.start < end && part.end > start);
      if (!parts.length || parts.some((part) => part.node.parentElement.closest(ignored))) return;
      const first = parts[0];
      const last = parts[parts.length - 1];
      const range = document.createRange();
      range.setStart(first.node, start - first.start);
      range.setEnd(last.node, end - last.start);
      range.deleteContents();
      range.insertNode(makeButton(code));
    });
  }

  function enhance() {
    document.querySelectorAll('#main-content .as-promo-code:not(button)').forEach((element) => {
      if (element.closest(ignored)) return;
      const code = element.textContent.trim();
      if (/^[a-z0-9][a-z0-9_-]*$/i.test(code)) {
        const button = makeButton(code);
        button.classList.add('as-promo-code');
        element.closest('.as-promo-line')?.classList.add('as-coupon-offer');
        element.replaceWith(button);
      }
    });
    document.querySelectorAll(offerSelectors.map((s) => `#main-content ${s}`).join(',')).forEach(enhanceOffer);
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('button.as-coupon-copy');
    if (!button) return;
    const label = button.querySelector('.as-coupon-copy__label');
    clearTimeout(timers.get(button));
    if (!status) {
      status = document.createElement('span');
      status.className = 'visually-hidden';
      status.setAttribute('role', 'status');
      document.body.append(status);
    }
    status.textContent = '';
    try {
      await navigator.clipboard.writeText(button.dataset.couponCode);
      label.textContent = 'Copied';
      status.textContent = `Coupon code ${button.dataset.couponCode} copied.`;
    } catch (_) {
      const range = document.createRange();
      range.selectNodeContents(button.querySelector('.as-coupon-copy__code'));
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      label.textContent = 'Copy manually';
      status.textContent = 'Automatic copying is unavailable. Select and copy the displayed code.';
    }
    timers.set(button, setTimeout(() => { label.textContent = 'Copy'; }, 3000));
  });
  document.addEventListener('shopify:section:load', enhance);
  document.addEventListener('on:variant:change', () => requestAnimationFrame(enhance));
  enhance();
})();
